import { createListQueryFn, MarketplaceApi } from "@xs2event/js-lib/api";

const marketPlaceApi = new MarketplaceApi();

export const useMarketplaceTickets = createListQueryFn(marketPlaceApi, "marktplaceticketsGet");

export const useMarketPlaceSales = createListQueryFn(marketPlaceApi, "mymarketplacesalesGet");
